export const RP = 'RP' // Rapport de production
export const RIRC = 'RI/RC' // Rapport d'intervention corrective
export const RIRP = 'RI/RP' // Rapport d'interventiom préventive
